import { useRachelChatContext } from '../contexts/Rachel.context';
import {
  RACHEL_AGENT_APPROVAL_DATA_PART,
  RachelAgentApprovalPayload,
} from '../effects/rachelAgentApproval.schema';

export const usePendingAgentApproval = (): RachelAgentApprovalPayload | null => {
  const { messages } = useRachelChatContext();
  const lastMessage = messages.at(-1);

  if (!lastMessage || lastMessage.role !== 'assistant') {
    return null;
  }

  const part = lastMessage.parts.find(
    (candidate) => candidate.type === RACHEL_AGENT_APPROVAL_DATA_PART,
  );

  return part && part.type === RACHEL_AGENT_APPROVAL_DATA_PART ? part.data : null;
};
